import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { async } from '@angular/core/testing';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { of, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { VariableMenuItem } from '../variable-menu.service';

@Component({
  standalone: true,
  imports: [
    GalaxyFormFieldModule,
    MatSelectModule,
    TranslateModule,
    ReactiveFormsModule,
    AsyncPipe,
    NgForOf,
    NgIf,
    GalaxyEmptyStateModule,
    MatButtonModule,
    MatIconModule,
  ],
  selector: 'app-variable-menu-item-selector',
  templateUrl: './variable-menu-item-selector.component.html',
  styleUrls: ['./variable-menu-item-selector.component.scss'],
})
export class VariableMenuItemSelectorComponent implements OnInit, OnDestroy {
  @Input() items: VariableMenuItem[];
  @Input() parentTextKey: string;
  @Output() variableMenuItemSelected = new EventEmitter<VariableMenuItem>();

  formControl: FormControl<VariableMenuItem> = new FormControl<VariableMenuItem>(null);
  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.subscriptions.push(
      this.formControl.valueChanges
        .pipe(
          switchMap((variableMenuItem) => {
            return variableMenuItem.subItems$ || of([]);
          }),
          map((subItems) => {
            // Check if it's a leaf node
            if (subItems.length == 0) {
              this.variableMenuItemSelected.emit(this.formControl.value);
            }
          }),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  childComponentVariableMenuItemSelected(variableMenuItem: VariableMenuItem): void {
    this.variableMenuItemSelected.emit(variableMenuItem);
  }

  protected readonly async = async;
}
